import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotArticlesSection from './components/HotArticlesSection';
import DailyContestSection from './components/DailyContestSection';
import CategorySection from './components/CategorySection';
import CommunityStatsSection from './components/CommunityStatsSection';
import TestimonialFaqSection from './components/TestimonialFaqSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <HotArticlesSection />
          <DailyContestSection />
          <CategorySection />
          <CommunityStatsSection />
          <TestimonialFaqSection />
        </article>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "91吃瓜社区 - 吃瓜群众聚集地",
            "description": "全网最大的吃瓜群众聚集地，分享黑料八卦、每日大赛与网红独家爆料，黑料正能量不打烊",
            "url": "https://91chigua.com",
            "isPartOf": {
              "@type": "WebSite",
              "name": "91吃瓜社区"
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "91吃瓜社区的爆料内容靠谱吗？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "91吃瓜社区有着严格的爆料审核机制，所有爆料内容都会经过多重交叉验证才会被推荐到首页。社区还设有实锤认证标签系统，经过时间验证的爆料会获得专属标识。"
                }
              },
              {
                "@type": "Question",
                "name": "如何在91吃瓜社区发布爆料？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "注册成为社区成员后，你可以在任意板块发布爆料帖子。我们鼓励大家提供真实可靠的信息来源，优质爆料帖会获得流量扶持和积分奖励。"
                }
              },
              {
                "@type": "Question",
                "name": "每日大赛是什么？怎么参与？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "每日大赛是91吃瓜社区最受欢迎的互动板块！每天中午12点，我们会精选当日最热的5条爆料话题进行投票PK。每位用户每天有3张投票权，可以投给自己认为最劲爆的瓜。"
                }
              },
              {
                "@type": "Question",
                "name": "91吃瓜社区收费吗？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "完全免费！91吃瓜社区始终秉持吃瓜自由的理念，所有公开内容均免费浏览。基础吃瓜功能永久免费开放。"
                }
              },
              {
                "@type": "Question",
                "name": "如何保护爆料人的隐私安全？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "91吃瓜社区高度重视爆料人的隐私保护。社区采用匿名投稿系统，所有爆料来源信息采用端到端加密存储，即使社区管理员也无法查看原始投稿人信息。"
                }
              }
            ]
          })}
        </script>
      </main>
      <Footer />
    </>
  );
}